import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import AppConfig from '../AppConfig';
import SupportLink from './SupportLink';
export default function Pricing(props) {
    const { userEmail } = props;
    const pricingTableRef = useRef(null);
    return (_jsxs("div", { children: [_jsx("stripe-pricing-table", { ref: pricingTableRef, "pricing-table-id": AppConfig.stripePricingTableId, "publishable-key": AppConfig.stripePricingTableKey, "customer-email": userEmail }), _jsxs("div", { id: "contactUsCustomPlan", style: { width: '100%', textAlign: 'center', fontSize: '24px' }, children: ["Have more than 200 xero organisations or specific needs, ", _jsx(SupportLink, {}), "."] })] }));
}
